<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">
        <h2>Draft Collection Digital Downloads</h2>

        <p>
            We are pleased to offer nearly all of our draft collections for sale as digital downloads
            in our <a target="_blank" href="http://store.handweaving.net/collections/weaving-drafts-collection">Online Store</a>.  These are an improved version of our former draft CDs.
        </p>

            <div class="inline-auto-width" style="vertical-align: top">
                <img style="vertical-align: top" class='right-padding bottom-padding' :src='getSiteImageUrl("download-sample-49812.png")' />
                <img style="vertical-align: top" class='bottom-padding right-padding' :src='getSiteImageUrl("download-icon-small.png")' />
            </div>
                    
            <div class="inline-auto-width" style="vertical-align: top">
                <ul style="padding-left: 13px; margin: 0">
                    <li>Full set of drafts included, also original works when available</li>
                    <li>Format is very similar to Handweaving.net listings, easy to browse</li>
                    <li>No weaving software required; WIFs are included for those who have it</li>
                    <li>Instant delivery and free updates, download link and installation instructions arrive by email</li>
                    <li>Install on multiple computers or devices that you own</li>
                    <li>Keep a permanent local offline copy of our draft collections</li>
                    <li>No Internet required to use after initial download</li>
                    <li>Compatible with Macintosh, Windows, and Linux computers</li>
                </ul>
            </div>

        <div class="vertical-padding">
            <a style="vertical-align: top" class="btn btn-primary" target="_blank" href="http://store.handweaving.net/collections/weaving-drafts-collection">Browse Available Draft Collection Downloads &raquo;</a>
        </div>

        <h2 class="top-padding">Free Sample</h2>
        <p>
            Please try this free sample digital download.  Similar downloads can now be purchased for nearly
            every draft collection on Handweaving.net!
        </p>

        <div style="width: 220px; float: left" class="bottom-padding">
            <a :href="storeProductUrl('elementary-textile-designing-draft-collection')" target="_blank">
                <img class="right-margin" style="border: 0.2em; border-color: black; border-style: solid" :src="getCollectionCoverImageUrlByFilename('ICS502Cover.png')" alt='Cover image for International Correspondence Schools Elementary Textile Designing, Serial 502'>
            </a>
        </div>
        <div style="float: left; width: 50%">
                <span style='font-weight: bold'>Elementary Textile Designing Serial 502</span> is a monograph published in the U.S.A. in
                1905 by International Correspondence Schools.  
                <a :href="storeProductUrl('elementary-textile-designing-draft-collection')" target="_blank">
                Download now
                </a> to get your own permanent copy of all 20 drafts
                and a PDF of the original monograph!
            <br />
            <br />
            <a style="vertical-align: top" class="btn btn-primary" target="_blank" :href="storeProductUrl('elementary-textile-designing-draft-collection')">Download Now &raquo;</a>
        </div>

        <h2 class="top-padding">Compatibility</h2>
        <p>
            Our draft collection downloads are compatible with Windows and Macintosh computers and laptops but not iPads.  It may be
            possible to use these with Android devices if you have software to extract zip archives.  To verify compatability, please try
            our free sample.
            <a name="installation"></a>
        </p>

        <h2 class="top-padding">Installation Instructions</h2>
        <p>
            Our downloads are provided in ZIP format, allowing just a single file to be downloaded for each.
            To install and run these, please complete the following steps.
        </p>
        <p>
            <ol>
                <li>Download the file containing the digital draft collection.  Choose Save or Save As... when asked, not Open.</li>
                <li>Save this to a directory or folder on your computer.</li>
                <li>
                    Extract the file's contents into a folder.
                    <ul>
                        <li>Windows: Right click the file and choose Extract All...</li>
                        <li>Mac: Double click the file</li>
                    </ul>
                </li>
                <li>
                    To open the collection, double click on the index.html file in the extracted folder.
                </li>
            </ol>
        </p>

        <h2 class="top-padding">License Information</h2>
        <p>
            Our draft collection downloads are licensed like CDs or books, intended for use by the original purchaser.
        </p>
        <p>
            You may use a purchased draft collection on multiple personal computers or devices and can make copies for backup purposes but may not provide copies to others. We offer these standalone draft collections for sale to provide permanent copies these drafts to weavers and to help finance Handweaving.net.
        </p>
        <p>
            Each draft collection is a derivative work containing a permanent local copy of drafts produced from drawdowns in the original work, incorporating corrections for errors.  When available, the original work is included in PDF format.  Just like a book or CD, draft collections can be used on any computer or device owned by the purchaser, without Internet access.
        </p>
      
        <helpUsButton/>
        <mailChimpSignup/>
    </b-container>

</template>

<script>
import mailChimpSignup from './MailChimpSignup.vue'
import helpUsButton from './HelpUsButton.vue'
import mediaService from '../mixins/mediaService.js'
export default {
    mixins: [mediaService],
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup
    },
    created() {
        this.$store.commit('setPageTitle', 'Draft Collection Digital Downloads')
    }
}
</script>

<style scoped>
.maxLogoHeight {
    max-height: 90px;
    height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/DigitalDownloads.vue